<template>
  <div class="contacts-navigation-wrapper">
    <ul id="contacts-navigation">
      <li>
        <router-link
          title="Контакты"
          v-bind:to="`/${contacts.alias}`"
        >
          <figure class="contacts-navigation-figure">
            <svg-sprite-icon
              class="navigation-icon"
              v-bind:src="'location'"
            ></svg-sprite-icon><!--
         --><figcaption>{{ contacts.short_name }}</figcaption>
          </figure>
        </router-link>
      </li><!--
   --><li>
      <a
        href="tel:+375-29-8888-099"
        title="Телефон"
      >
        <figure class="contacts-navigation-figure">
          <svg-sprite-icon
            class="navigation-icon"
            v-bind:src="'phone'"
          ></svg-sprite-icon><!--
       --><figcaption>+375 (29) 8888-099</figcaption>
        </figure>
      </a>
    </li>
    </ul>
  </div>
</template>

<script>
import SvgSpriteIcon from '@/components/utils/SvgSpriteIcon'

export default {
  name: 'NavigationContacts',
  props: ['contacts'],
  components: { SvgSpriteIcon },
  data: function () {
    return {}
  }
}
</script>

<style lang="scss">
  .contacts-navigation-wrapper {
    @include media(">desktop") {
      height: $the-header-contacts-height;
      border-bottom: 1px solid #333;
    }
    @include media("<=desktop") {
      height: $the-header-main-height;
      position: absolute;
      top: 0;
      right: 10px;
    }
  }

  #contacts-navigation {
    float: right;
    margin: 0;
    @include media("<=desktop") {
      line-height: $the-header-main-height;
    };

    & > li > a {
      display: inline-block;
      line-height: $the-header-contacts-height;
      padding: 0 10px;
      font-size: 11px;
      letter-spacing: 0.25em;
      text-transform: uppercase;

      & > .contacts-navigation-figure {
        & > .navigation-icon {
          display: inline-block;
          height: 30px;
          width: 30px;
          vertical-align: middle;

          @include media(">desktop") {
            padding-right: 1em;
            height: $the-header-contacts-height / 2;
          };
          @include media("<=desktop") {
            display: inline-block;
          };
        }
        & > figcaption {
          @include media(">desktop") {
            display: inline-block;
          }
          @include media("<=desktop") {
            display: none;
          };
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-header/NavigationContacts.vue